import * as Yup from 'yup';

const objectIdRegex = /^[a-f\d]{24}$/i;

const defaultApprover = {
    company_id: '',
    name: '',
    email: '',
};

export const approverSchema = Yup.object().shape({
    company_id: Yup.string()
        .matches(objectIdRegex, 'Invalid Company ID')
        .required('Company ID is required'),
    name: Yup.string()
        .required('Name is required'),
    email: Yup.string()
        .email('Invalid email')
        .required('Email is required'),
});

export const updateApproverSchema = Yup.object().shape({
    company_id: Yup.string()
        .matches(objectIdRegex, 'Invalid Company ID'),
    name: Yup.string(),
    email: Yup.string()
        .email('Invalid email'),
});

export const getValidationSchema = (modal) => {
    if (modal === 'add') {
        return approverSchema;
    } else if (modal === 'edit') {
        return updateApproverSchema;
    }
    return approverSchema;
};

export const getInitialValues = (modal, selectedItem) => {
    if (modal === 'add') {
        return {
            ...defaultApprover,
        };
    } else if (modal === 'edit' && selectedItem) {
        return {
            company_id: selectedItem.company_id || '',
            name: selectedItem.name || '',
            email: selectedItem.email || '',
        };
    }

    return {
        ...defaultApprover,
    };
};